function generateId(): string {
  return (
    Math.random().toString(36).substring(2) + new Date().getTime().toString(36)
  )
}

export interface Todo {
  id: string
  text: string
  completed: boolean
}

export interface Goal {
  id: string
  text: string
}

export const saveTodo = (name: string): Promise<Todo> =>
  new Promise<Todo>((resolve, reject) => {
    if (!name) {
      reject(new Error('name cannot be null'))
    }

    const result = { id: generateId(), text: name, completed: false }

    setTimeout(() => resolve(result), 250)
  })

export const saveTodoToggle = (id: string): Promise<boolean> =>
  new Promise<boolean>((resolve, reject) => {
    if (!id) {
      reject(new Error('id cannot be null'))
    }

    setTimeout(() => resolve(true), 250)
  })

export const deleteTodo = (id: string): Promise<boolean> =>
  new Promise<boolean>((resolve, reject) => {
    if (!id) {
      reject(new Error('id cannot be null'))
    }

    setTimeout(() => resolve(true), 250)
  })

export const saveGoal = (name: string): Promise<Goal> =>
  new Promise<Goal>((resolve, reject) => {
    if (!name) {
      reject(new Error('name cannot be null'))
    }

    const result = { id: generateId(), text: name }

    setTimeout(() => resolve(result), 250)
  })

export const deleteGoal = (id: string): Promise<boolean> =>
  new Promise<boolean>((resolve, reject) => {
    if (!id) {
      reject(new Error('id cannot be null'))
    }

    setTimeout(() => resolve(true), 250)
  })
